import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { type ModalProps } from './modal';
import { modalClasses } from './modal.classes';
import { useModalStyles } from './modal.styles';

import type { JSX } from 'react';

export const ModalLargeOrMediumViewport = ({
  isOpen,
  className,
  verticalPosition,
  styles,
  children,
  role,
  onClose,
  ...rest
}: ModalProps): JSX.Element => {
  const css = useModalStyles({ verticalPosition });

  return (
    <Modal
      {...rest}
      onClose={onClose}
      role={role ?? 'dialog'}
      aria-modal='true'
      open={isOpen}
      className={className}
      slotProps={{
        root: { className: modalClasses.root },
        backdrop: {
          classes: { root: modalClasses.backdrop },
          style: styles?.backdrop,
          sx: css.backdrop,
        },
      }}
      style={styles?.root}
      css={css.root}
    >
      <Box className={modalClasses.container} style={styles?.container}>
        {children}
      </Box>
    </Modal>
  );
};
